import Swiper from 'swiper'
import { Scrollbar } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/scrollbar'

(() => {
    // Find the wrapper containers so we can easily target children
    const scrollingContainers = document.querySelectorAll(".scrollinglist");

    if (scrollingContainers.length) {
        scrollingContainers.forEach((container) => {
            // Find the specific swiper instance and scrollbar within this block
            const swiperEl = container.querySelector(".listSwiper");
            const scrollbarEl = container.querySelector(".swiper-scrollbar");

            if (swiperEl && scrollbarEl) {
                const swiper = new Swiper(swiperEl, {
                    modules: [Scrollbar],
                    slidesPerView: "auto",
                    spaceBetween: 30,
                    scrollbar: {
                        el: scrollbarEl, // Directly hands the element to Swiper
                        hide: false,
                        draggable: true,
                    },
                });
            }
        });
        document.body.style.overflowX = "hidden";
    }
})();
